/* eslint-disable @typescript-eslint/ban-types */
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import { getAppConfigurations } from './environment-variables'

const {
  datadogClientToken,
  datadogApplicationId,
  datadogService,
  environment,
  appVersion
} = getAppConfigurations()

class Logger {
  public init() {
    if (environment === 'local') {
      return
    }

    const defaultConfig = {
      clientToken: datadogClientToken,
      site: 'datadoghq.eu',
      service: datadogService,
      env: environment,
      sampleRate: 100,
      version: appVersion
    }

    datadogLogs.init({
      ...defaultConfig,
      forwardErrorsToLogs: true
    })

    datadogRum.init({
      ...defaultConfig,
      applicationId: datadogApplicationId,
      trackInteractions: true,
      defaultPrivacyLevel: 'mask'
    })

    datadogRum.startSessionReplayRecording()

    window.onerror = (msg, url, lineNo, columnNo, error) => {
      this.logError(error, { errorType: 'JAVSCRIPT_ERROR' })
    }

    window.onunhandledrejection = (error: PromiseRejectionEvent) => {
      this.logError(error, { errorType: 'UNHANDLED_REJECTION' })
    }
  }
  public logInfo(msg: string, params?: object) {
    this.log(msg, 'info', params)
  }
  public logError(error: unknown, context?: object) {
    datadogRum.addError(error, context)
  }
  public trackPageView(page: string) {
    if (environment === 'local') {
      return
    }

    datadogRum.startView(page)
  }
  private log(
    msg: string,
    type: 'debug' | 'info' | 'warn' | 'error',
    params?: object
  ) {
    if (environment === 'local') {
      console[type](msg, params)
    } else {
      datadogLogs.logger[type](msg, params)
    }
  }
}

const instance = new Logger()

export default instance
